import { Colors } from 'works/legacy/lib/style-helper';

const AccountColors = [
  Colors.sun,
  Colors.coral,
  Colors.grass,
  Colors.harvestGold,
  Colors.hypnotiqRegular,
  Colors.skyRegular,
  Colors.skyLighter,
  Colors.rubyRed,
  Colors.elmLighter,
];

function sample(array: string[]) {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}

export function randomAccountColor(
  options: { exclude: string[] } = { exclude: [] }
) {
  return sample(
    AccountColors.filter((color) => !options.exclude.includes(color))
  );
}
